const AuthorRoleEnum = {
    AUTHOR: 'Author',
    CORRESPONDING_AUTHOR: 'Corresponding Author',
    RESPONSIBLE_CORRESPONDING_AUTHOR: 'Responsible Corresponding Author',
} as const;

export default AuthorRoleEnum;
